<template>
    <div class="company-clients-page">
        <breadcrumbs class="mb-3" />
        <page-title :text="$t('page_titles.company_clients_page_title')" />
        <div class="company-clients-page__header mb-4 d-flex align-center flex-wrap">
            <v-btn
                data-cy="link-client-page"
                variant="flat"
                :to="{name: 'companyClient', params: {id: 0}}"
                class="me-2 mb-2 bg-primary"
            >
                {{ $t('new_client_profile') }}
            </v-btn>
            <v-btn
                class="me-2 mb-2"
                variant="outlined"
                color="primary"
                :disabled="!selectedClients.length"
                data-cy="show-edit-clients-modal"
                @click="isEditClientsModal = true"
            >
                {{ $t('edit_clients_profiles') }}
            </v-btn>
            <v-btn
                v-if="isTO1"
                class="mb-2"
                variant="outlined"
                color="primary"
                :disabled="!emails.length"
                data-cy="show-email-modal"
                @click="emailModal = true"
            >
                {{ $t('send_email') }}
            </v-btn>
        </div>
        <clients-table
            ref="table"
            :is-member="false"
            :users="users"
            :users-loading="usersLoading"
            @change-selected-emails="emails = $event"
            @change-selected-clients="selectedClients = $event"
        />
        <edit-clients-modal
            v-model="isEditClientsModal"
            :clients="selectedClients"
            :users="users"
            :users-loading="usersLoading"
            @close="isEditClientsModal = false"
            @sent="updateClientData"
        />
        <send-clients-email-modal v-model="emailModal" :emails="emails" @sent="$refs.table.selected = []" />
    </div>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import Breadcrumbs from '~src/components/breadcrumbs.src'
    import ClientsTable from '~src/components/account/clientsTable.src'
    import SendClientsEmailModal from '@/components/account/modals/SendClientsEmailModal.vue'
    import EditClientsModal from '@/components/account/modals/EditClientsModal.vue'
    import PageTitle from '~/components/parts/PageTitle.vue'

    @Component({
        components: {
            SendClientsEmailModal,
            EditClientsModal,
            Breadcrumbs,
            ClientsTable,
            PageTitle,
        },
    })
    export class CompanyClientsPage extends Vue {
        emails: string[] = []
        selectedClients: number[] = []
        emailModal: boolean = false
        isEditClientsModal: boolean = false
        usersLoading: boolean = false
        users = []

        async mounted() {
            await this.loadUsers()
        }

        async loadUsers() {
            try {
                this.usersLoading = true
                this.users = (await this.$api.persons.get({companyId: authStore.company.id})).users
                    .map(({personId, firstName, lastName}) => ({
                        personId,
                        name: `${lastName || ''} ${firstName || ''}`.trim(),
                    }))
                    .sort((a, b) => a.name.localeCompare(b.name))
            } catch (e) {
                this.users = []
            } finally {
                this.usersLoading = false
            }
        }

        updateClientData() {
            this.isEditClientsModal = false
            this.$refs.table.selected = []
            this.$refs.table.loadPrivateClients()
        }

        get isTO1() {
            return authStore.isTO1
        }
    }

    export default CompanyClientsPage
</script>
